// src/utils/style/elements.tsx

import styled from "styled-components";
// import colors from "./colors.tsx";

export const Titre = styled.h1`
    font-size: 36px;
    font-weight: 700;

    @media (max-width: 768px) {
        font-size: 24px;
    }
`

export const SousTitre = styled.h2`
    font-size: 20px;

    @media (max-width: 768px) {
        font-size: 14px;
    }
`

export const Texte = styled.p`
    font-size: 24px;

    @media (max-width: 768px) {
        font-size: 16px !important;
    }
`

export const MiniTexte = styled.p`
    font-size: 18px;

    @media (max-width: 768px) {
        font-size: 8px;
    }
`

export const PetitTexte = styled.p`
    @media (max-width: 768px) {
        font-size: 10px;
    }
`

export const TexteFooter = styled.p`
    font-size: 20px;

    @media (max-width: 768px) {
        font-size: 18px;
    }
`


